export const buttonCancel = 'w-150px h-60px mx-4';
export const buttonSubmit = 'w-200px h-60px mx-4';
export const buttonPreview = 'w-200px h-60px mx-4';
export const largeButtonsPadding = 'py-10';